import { render } from "./ProjectVoteModal.vue?vue&type=template&id=2dab5835"
import script from "./ProjectVoteModal.vue?vue&type=script&lang=js"
export * from "./ProjectVoteModal.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ProjectVoteModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2dab5835"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2dab5835', __exports__)) {
    api.reload('2dab5835', __exports__)
  }
  
  module.hot.accept("./ProjectVoteModal.vue?vue&type=template&id=2dab5835", () => {
    api.rerender('2dab5835', render)
  })

}


export default __exports__